import axios from 'axios';
import { Navigate, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

// Action Types
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const LOGOUT_APP = 'LOGOUT_APP';

export const loginRequest = () => ({ type: LOGIN_REQUEST });
export const loginSuccess = (user) => ({ type: LOGIN_SUCCESS, payload: user });
export const loginFailure = (error) => ({ type: LOGIN_FAILURE, payload: error });
export const loginRefreshToken = (data) => ({ type: REFRESH_TOKEN, payload: data });
export const logoutApp = () => ({ type: LOGOUT_APP, payload: null });
export const forgotPassSuccess = () => ({ type: LOGIN_SUCCESS, payload: "" });
export const checkValidResetLinkRequest = () => ({ type: "CHECK_VALID_RESET_LINK_REQUEST" });
export const checkValidResetLinkSuccess = () => ({ type: "CHECK_VALID_RESET_LINK_SUCCESS", payload: "" });
export const checkValidResetLinkFailure = (error) => ({ type: "CHECK_VALID_RESET_LINK_FAILURE", payload: error });


export const login = (email, password) => async (dispatch) => {  
  dispatch(loginRequest());
  let requestData= {
    email:email,
    password:password,
  }
  try {
    // Simulate API call
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/auth/login`, requestData);
    if(response.status === false){
        dispatch(loginFailure('Invalid email or password!'));
        toast.error('Invalid email or password!');
    }else{
        const user = response.data;
        dispatch(loginSuccess(user));
        toast.success('Login successful!');   
        
        localStorage.setItem('auth_token', response.data.id_token);
        localStorage.setItem('refreshToken', response.data.refresh_token);     
    }
    
  } catch (error) {
    toast.error('Session Expired');
    dispatch(LogoutApp());
  }
};
export const forgot_password = (email) => async (dispatch) => {  
    dispatch(loginRequest());
    let requestData= {
      email:email,
    }
    try {
      // Simulate API call
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/auth/forgot-password`, requestData);
      console.log(response.data);
      if(response.data.success === true){
        dispatch(forgotPassSuccess());
        toast.success(response.data.message);           
      }else{
        dispatch(loginFailure('Something went wrong , Please try again!'));
        toast.error('Something went wrong , Please try again!')    
      }
      
    } catch (error) {
      toast.error('Session Expired');
      dispatch(LogoutApp());
    }
};

export const isLinkValid = (auth_code) => async (dispatch) => {  
    dispatch(loginRequest());
    
    try {
        // Simulate API call
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/auth/activate/${auth_code}`);
        
        if (response.data.success) {
            dispatch(forgotPassSuccess());
            const message = response.data.message || "Your account has been activated.";
            toast.success(message);
            return response.data; // Return the response data
        } else {
            const errorMsg = 'Something went wrong, Please try again!';
            dispatch(loginFailure(errorMsg));
            toast.error(errorMsg);
            return { success: false, message: errorMsg };
        }
        
    } catch (error) {
        const errorMsg = 'Session Expired';
        toast.error(errorMsg);
        dispatch(LogoutApp());
        return { success: false, message: errorMsg };
    }
};

export const checkValidResetLink = (auth_code) => async (dispatch) => {  
    dispatch(checkValidResetLinkRequest());
    
    try {
        // Simulate API call
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/auth/check-reset-link/${auth_code}`);
        
        if (response.data.success) {
            dispatch(checkValidResetLinkSuccess());
            const message = response.data.message ;
            toast.success(message);
            return response.data; // Return the response data
        } else {
            const errorMsg = 'Something went wrong, Please try again!';
            dispatch(checkValidResetLinkFailure(errorMsg));
            toast.error(errorMsg);
            return { success: false, message: errorMsg };
        }
        
    } catch (error) {
        const errorMsg = error.response.data.message;
        toast.error(errorMsg);
        // dispatch(LogoutApp());
        // return (<Navigate to={"/forgot-password"} />) 
        return error.response.data;
    }
};
export const userActivation = (activatekey) => async (dispatch) => {
    try {
        // Simulate API call
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/account/activate/${activatekey}`);
        
        if (response.data.success) {
            const message = response.data.message ;
            toast.success(message);
            return response.data; // Return the response data
        } else {
            const errorMsg = 'Something went wrong, Please try again!';
            toast.error(errorMsg);
            return { success: false, message: errorMsg };
        }
        
    } catch (error) {
        const errorMsg = error.response.data.message;
        // toast.error(errorMsg);
        // dispatch(LogoutApp());
        // return (<Navigate to={"/forgot-password"} />) 
        return error.response.data;
    }
};
export const reset_password = (code, password) => async (dispatch) => {  
    dispatch(loginRequest());
    let requestData= {
        resetKey:code,
        password:password,
    }
    try {
        // Simulate API call
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/auth/reset-password`, requestData);
        if(response.data.success === true){
            dispatch(forgotPassSuccess());
            toast.success(response.data.message);        
            return (<Navigate to={"/login"} />)    
        }else{
        dispatch(loginFailure('Something went wrong , Please try again!'));
        toast.error('Something went wrong , Please try again!')    
        }
        
    } catch (error) {
        toast.error('Session Expired');
        dispatch(LogoutApp());
    }
};

export const UserDetails = () => async (dispatch) => { 
    const authToken = localStorage.getItem('auth_token');
    if (!authToken) {
        toast.error('Authentication token missing. Please log in.');
        return dispatch(LogoutApp());
    }

    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/user`, {
            headers: { Authorization: `Bearer ${authToken}` },
        });
        console.log("response UserDetails", response);
        localStorage.setItem('user', JSON.stringify(response.data));
        dispatch({ type: "USER", payload: response.data });
    } catch (error) {
        if (error.response && error.response.status === 401) {
            toast.error('Session Expired. Please log in again.');
            dispatch(LogoutApp());
        } else {
            console.error("Error fetching user details: ", error.response ? error.response.data : error.message);
            toast.error('Failed to fetch user details.');
        }
    }
    /* const auth_token = localStorage.getItem('auth_token');
    let headerData = {
        "Authorization":`Bearer ${auth_token}`
    }
    try {
        // Simulate API call
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/user`, {headers: headerData });
        console.log("response UserDetails",response);
        localStorage.setItem('user', JSON.stringify(response.data));
        dispatch({ type: "USER", payload: response.data });
        
    } catch (error) {
        console.log("error",error)
        toast.error('Session Expired');
        dispatch(LogoutApp());
    } */
};

export const getAllUsersDetails = () => async (dispatch) => { 
    const authToken = localStorage.getItem('auth_token');
    if (!authToken) {
        toast.error('Authentication token missing. Please log in.');
        return dispatch(LogoutApp());
    }

    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/account/list`, {
            headers: { Authorization: `Bearer ${authToken}` },
        });
        dispatch({ type: "ALL_USERS", payload: response.data });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            toast.error('Session Expired. Please log in again.');
            dispatch(LogoutApp());
        } else {
            console.error("Error fetching user details: ", error.response ? error.response.data : error.message);
            toast.error('Failed to fetch user data.');
        }
    }
};
export const createUser = (formData) => async (dispatch) => { 
    const authToken = localStorage.getItem('auth_token');
    if (!authToken) {
        toast.error('Authentication token missing. Please log in.');
        return dispatch(LogoutApp());
    }
    let data = JSON.stringify(formData);
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/account`,formData, {
            headers: { Authorization: `Bearer ${authToken}` },
        });
        console.log("response CREATE_USER", response);
        if(response.data.success){
            toast.success(response.data.message);  
        }else{
            toast.error(response.data.message);  
        }
        return response.data;
        // dispatch({ type: "CREATE_USER", payload: formData });
    } catch (error) {
        if (error.response && error.response.status === 401) {
            toast.error('Session Expired. Please log in again.');
            dispatch(LogoutApp());
        } else {
            console.error("Error fetching user details: ", error.response ? error.response.data : error.message);
            toast.error('Failed to fetch user data.');
        }
    }
};
export const refreshToken = () => async (dispatch) => { 
    const refreshToken = localStorage.getItem('refreshToken');
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/auth/refresh`, {refresh_token: refreshToken });
        if(response.status===false){
            dispatch(loginFailure('Incorrect Token!'));
            toast.error('Incorrect Token!');
            dispatch(LogoutApp());
        }else{
            localStorage.setItem('auth_token', response.data.id_token);
            const data = response.data;
            dispatch(loginRefreshToken(data));
            // toast.success('Login successful!'); 
        }
        
    } catch (error) {
        toast.error('Session Expired');
        dispatch(LogoutApp());
    }
    
};

export const LogoutApp = () => async (dispatch) => { 
    const auth_token = localStorage.getItem('auth_token');

    try {
        
        let headerData = {
            "Authorization":`Bearer ${auth_token}`
        }
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/auth/logout`, {headers: headerData });
        localStorage.removeItem('user');
        localStorage.removeItem('auth_token');
        localStorage.removeItem('refreshToken');
        dispatch(logoutApp());
        toast.success('Logout successful!');  
        return (<Navigate to={"/login"} />) 
        
    } catch (error) {
        localStorage.removeItem('user');
        localStorage.removeItem('auth_token');
        localStorage.removeItem('refreshToken');
        dispatch(logoutApp());
        // toast.success('');  
        return (<Navigate to={"/login"} />) 
    }
   
    
};